
   
  
<div class="row">

  <div class="nk-column1" *ngIf="DoctorsList">

    <div class="card paddin-left-5px">

      <div class="card-header wh-header header3 padding-right-32px bk-color-sky padding-bottom-0px">

        <div class="row margin-top10px nav-link-hand">

          
            <label class="wh-header font-weight-normal labcolor border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-sky">
              Provider Calendar
            </label>
         
        

        </div>
        
      </div>
      <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-sky">
        <div class="row padding-top-5px padding-bottom-10px margin-right-0px margin-left-5px">
          <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

        </div>
        <div>
          <div class="chatsd product-chart-wrapper product-chat-height-557 agreement-chart-wrapper ps2 padding-lrt ">
            <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" (click)="slotdetails()">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2">Dr.DOCT-43</label>
                    </div>

                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
                    </div>

                  </div>

                </div>

                
              </div>
            </div>

            <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">
                              
                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2">Dr.DOCT-45</label>
                    </div>

                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
                    </div>

                  </div>

                </div>




              </div>
            </div>




          </div>
        </div>

      </div>

    </div>
  </div>



  <div class="nk-column2" *ngIf="SelectedDoctor">
    <div class="padding-right-0px background-white">
      <div class="">

        <div class="card">



          <div class="card-header background-white border-bottom-0 padding-bottom-0px pad5">
            <div class="row">
              <div class="col-md-1 margin-left-10px">
                <div class="row">
                  <a class="user-image-circle-65px">
                    <img class="img3" src="DR SITARAM.jpg">
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row a1">
                  <label class="margin-bottom-0px f2">Dr.DOCT-43</label>
                </div>
                <div class="row a1">
                  <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
                </div>
                <div class="row a1">
                  <label class="margin-bottom-0px f3">Cardiologist</label>
                </div>

              </div>

              <div class="col-md-4 padding-top-15px">

                <div class="row float-right">
                  <div class="col-md-6 padding-right-0px">
                    <label class="margin-bottom-0px f2">Location</label>
                  </div>

                  <div class="col-md-6 padding-left-0px">
                    <div class="input-group">
                      <label>
                        <select class="">
                          <option value=" ">  </option>
                          <option value="Electronic city"> Electronic city </option>
                          <option value="Kengeri"> Kengeri </option>
                          <option value="Kalyani Nagar"> Kalyani Nagar </option>
                        
                        </select>
                      </label>
                    </div>
                  </div>
                  </div>

                </div>



            </div>


          </div>

          <div class="card-body background-white padding-top-2px padding-left-5px padding-right-5px">


            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px padding-left-0px">
              
              <div class="chatsd product-chart-wrapper product-chat-height-562 agreement-chart-wrapper ps2 padding-lrt ">
                <div class="table-component b1 margin-top-15px">
                  <div class="table-responsive overflow-x">


                    <table class="table table-striped margin-left-zero"
                           cols="auto,2*,*,*,*,*,*,*">

                      <thead class="">
                        <tr>


                          <th class="border-top0 padding-top-4px padding-bottom-4px font-weight-normal">
                            Slot Timings
                          </th>


                          <th class="border-top0 padding-top-4px padding-bottom-4px font-weight-normal text-align-center">
                            Monday
                          </th>
                          <th class="border-top0 padding-top-4px padding-bottom-4px font-weight-normal text-align-center">
                            Tuesday
                          </th>

                          <th class="border-top0 padding-top-4px padding-bottom-4px font-weight-normal text-align-center">
                            Wednesday
                          </th>

                          <th class="border-top0 padding-top-4px padding-bottom-4px font-weight-normal text-align-center">
                            Thursday
                          </th>
                          <th class="border-top0 padding-top-4px padding-bottom-4px font-weight-normal text-align-center">
                            Friday
                          </th>
                          <th class="border-top0 padding-top-4px padding-bottom-4px font-weight-normal text-align-center">
                            Saturday
                          </th>
                          <th class="border-top0 padding-top-4px padding-bottom-4px font-weight-normal text-align-center">
                            Sunday
                          </th>

                        </tr>

                        <tr>

                          <th class="f3 padding-top-4px padding-bottom-4px font-weight-normal" href="#colapse1" data-toggle="collapse">Morning</th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"></th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>

                        </tr>
                      </thead>

                      <tbody id="colapse1" class="table-body collapse">

                        <tr>

                          <td class="f3 padding-top-4px padding-bottom-4px">8:00AM - 9:00AM</td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>

                        </tr>

                        <tr>

                          <td class="f3 padding-top-4px padding-bottom-4px">10:00AM - 11:00AM</td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>

                        </tr>

                      </tbody>

                      <thead>
                        <tr>

                          <th class="f3 padding-top-4px padding-bottom-4px font-weight-normal" href="#colapse2" data-toggle="collapse">Afternoon</th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"></th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>
                          <th class="f3 padding-top-4px padding-bottom-4px text-align-center"> </th>

                        </tr>

                      </thead>
                                           
                      <tbody id="colapse2" class="table-body collapse">

                        <tr>

                          <td class="f3 padding-top-4px padding-bottom-4px">2:00PM - 3:00PM</td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>

                        </tr>

                        <tr>

                          <td class="f3 padding-top-4px padding-bottom-4px">4:00PM - 5:00PM</td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>
                          <td class="f3 padding-top-4px padding-bottom-4px text-align-center"><input type="checkbox" class="checkbox1" /></td>

                        </tr>
                                                
                      </tbody>


                    </table>
                                       

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
   
</div> 








